/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { useTranslation } from "react-i18next";
//Foundation libraries
import { useSite } from "../../../_foundation/hooks/useSite";
import { PriceDisplay, StyledGrid } from "@hcl-commerce-store-sdk/react-component";

/**
 * Formatted Price or Price Range Display component
 * displays a price or price range between min price to max price that is formatted to the currency and locale or show price pending if price is not available
 */
const CustomFormattedPriceDisplay = (props: any) => {
  const { mySite } = useSite();
  const { i18n } = useTranslation();
  const min = props.min;
  const max = props.max ? props.max : null;
  const currency = props.currency ? props.currency : mySite ? mySite.defaultCurrencyID : "";

  const { t } = useTranslation();
  const message = t("PriceDisplay.Labels.Pending");
  const language = i18n.languages[0];

  const priceParts = parseFloat(min).toFixed(2).split(".");
  const punctuatedPrice = priceParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (priceParts[1] ? "." + priceParts[1] : "");
  const cleanFormattedPrice = punctuatedPrice.replace("-", "");
  const isNegative = (punctuatedPrice[0] === "-") ? true : false;
  const formattedPrice = isNegative ? ("-$" + cleanFormattedPrice) : ("$" + cleanFormattedPrice);


  return (
    <>
      <StyledGrid style={{ display: "flex" }}>{formattedPrice}</StyledGrid>
      {/* <div>{currency}</div> */}
    </>
  );
  // <PriceDisplay {...{ min, max, currency, message, language }} />;
};

export default CustomFormattedPriceDisplay;
